<template>
  <div class="home">
    <cash-hero-header />

    <home-easy-step />

    <home-product-section />

    <home-eligible />

    <home-why-us-section />

    <home-rating-and-recommendation />

    <v3-cash-hero-footer />
  </div>
</template>

<script>
import CashHeroHeader from '../partials/CashHeroHeader'
import HomeProductSection from '@/views/includes/home/HomeProductSection'
import HomeWhyUsSection from '@/views/includes/home/HomeWhyUsSection'
import V3CashHeroFooter from '@/partials/v3/V3CashHeroFooter'
import HomeEasyStep from '@/views/includes/home/HomeEasyStep'
import HomeEligible from './includes/home/HomeEligible'
import HomeRatingAndRecommendation from '@/views/includes/home/includes/HomeRatingAndRecommendation'

export default {
  name: 'Home',
  metaInfo: {
    title: 'Home',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Cash hero website' }
    ]
  },
  components: {
    HomeRatingAndRecommendation,
    HomeEligible,
    HomeEasyStep,
    V3CashHeroFooter,
    HomeWhyUsSection,
    HomeProductSection,
    CashHeroHeader
  }
}
</script>

<style scoped>

</style>
